import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/auth.png'


const _withScopeId = n => (_pushScopeId("data-v-3c89b1fa"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "head" }
const _hoisted_2 = { class: "head_item" }
const _hoisted_3 = { class: "icon" }
const _hoisted_4 = { class: "left" }
const _hoisted_5 = { class: "left_top" }
const _hoisted_6 = { class: "name" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"flex":"1"} }, null, -1))
const _hoisted_8 = {
  key: 0,
  class: "auth"
}
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1))
const _hoisted_10 = { class: "left_bottom" }
const _hoisted_11 = { class: "head_item1" }
const _hoisted_12 = { class: "right1" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"color":"#9d9d9d"} }, "(USDT)", -1))
const _hoisted_14 = { class: "right2" }
const _hoisted_15 = { class: "balance" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_document_copy = _resolveComponent("document-copy")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_refresh = _resolveComponent("refresh")!
  const _component_el_row = _resolveComponent("el-row")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_row, null, {
      default: _withCtx(() => [
        _createVNode(_component_el_col, {
          span: 12,
          offset: 0
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.user.nickName ? _ctx.user.nickName.substring(0, 1) : _ctx.user.username.substring(0, 1)), 1),
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("div", _hoisted_5, [
                  _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.user.nickName ? _ctx.user.nickName : _ctx.user.username), 1),
                  _createElementVNode("div", {
                    class: "id",
                    onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.copyAction && _ctx.copyAction(...args)))
                  }, "ID:" + _toDisplayString(_ctx.user.userId), 1),
                  _createVNode(_component_el_icon, {
                    class: "pointer fontBright",
                    onClick: _ctx.copyAction,
                    size: 16
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_document_copy)
                    ]),
                    _: 1
                  }, 8, ["onClick"]),
                  _hoisted_7,
                  (_ctx.merchant == 1)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                        _hoisted_9,
                        _createElementVNode("div", null, _toDisplayString(_ctx.langObj.l0128), 1)
                      ]))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", _hoisted_10, [
                  _createElementVNode("div", null, _toDisplayString(_ctx.langObj.l0129 + "：" + _ctx.user.phone), 1),
                  _createElementVNode("div", null, _toDisplayString(_ctx.langObj.l0130 +
                                        "：" +
                                        _ctx.formatDateTime(_ctx.user.createTime ? _ctx.user.createTime : 1611368449782)), 1)
                ])
              ])
            ])
          ]),
          _: 1
        }),
        _createVNode(_component_el_col, {
          span: 12,
          offset: 0
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("div", _hoisted_12, [
                _createTextVNode(_toDisplayString(_ctx.langObj.l0110) + " ", 1),
                _hoisted_13
              ]),
              _createElementVNode("div", _hoisted_14, [
                _createElementVNode("div", _hoisted_15, [
                  _createElementVNode("div", null, _toDisplayString(_ctx.balance), 1),
                  _createVNode(_component_el_icon, {
                    size: 24,
                    class: _normalizeClass(["el-icon-refresh", _ctx.startRefresh ? 'refresh rotate' : 'refresh']),
                    onClick: _ctx.refresh
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_refresh)
                    ]),
                    _: 1
                  }, 8, ["class", "onClick"])
                ])
              ])
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ]))
}